// Tipos preview do contrato de Notifications (M1 §6.3/§7.2) — TODO(GIY-025): substituir por
// `components['schemas'][…]` de `@giyus/api-client` quando o contrato trouxer estas rotas (integração pós A/B).
import type { SignatureMeaning } from '../../../components/signatureMeanings';

export type TemplateVersionStatus = 'Draft' | 'InReview' | 'Approved' | 'Retired';
export type TemplateAudience = 'Participant' | 'Internal';
export type TemplateChannel = 'Email' | 'Sms';

export interface MergeFieldDeclaration {
  readonly name: string;
  readonly source: string;
}

export interface MessageTemplateSummary {
  readonly id: string;
  readonly key: string;
  readonly channels: readonly TemplateChannel[];
  readonly audience: TemplateAudience;
  readonly sender: string;
  readonly mandatory: boolean;
  readonly currentVersionStatus: TemplateVersionStatus;
  readonly currentVersion: number;
}

export interface TemplateLocaleContent {
  readonly subject: string;
  readonly bodyHtml: string;
  readonly bodyText?: string | null;
}

export interface MessageTemplateVersion {
  readonly templateId: string;
  readonly key: string;
  readonly version: number;
  readonly status: TemplateVersionStatus;
  readonly mergeFields: readonly MergeFieldDeclaration[];
  readonly locales: {
    readonly 'pt-BR': TemplateLocaleContent;
    readonly 'en-US': TemplateLocaleContent;
  };
  readonly objectContentHash: string;
  readonly approvalRequestId?: string | null;
  readonly changeReason?: string | null;
  readonly createdAt: string;
  readonly createdBy: string;
  readonly etag: string;
}

export interface TemplateApprovalState {
  readonly approvalRequestId: string;
  readonly actType: string;
  readonly step: number;
  readonly status:
    'Pending' | 'PendingSecondKey' | 'Approved' | 'Rejected' | 'Returned' | 'Expired';
  readonly requiresSignature: boolean;
  readonly allowedMeanings: readonly SignatureMeaning[];
  readonly objectContentHash: string;
}

export interface TestSendRequest {
  readonly locale: 'pt-BR' | 'en-US';
  readonly recipient: { readonly self: true } | { readonly address: string };
  readonly sampleData?: Readonly<Record<string, string>>;
}

export interface DoNotContactWindow {
  readonly days: readonly number[];
  readonly start: string;
  readonly end: string;
  readonly timeZoneId: string;
}

export interface NotificationPreferences {
  readonly channels: { readonly email: boolean; readonly sms: boolean };
  readonly preferredLocale: 'pt-BR' | 'en-US' | null;
  readonly doNotContactWindows: readonly DoNotContactWindow[];
  readonly smsAvailable: boolean;
  readonly mandatoryCategories: readonly string[];
  readonly etag: string;
}

export const NOTIFICATIONS_PREVIEW_PATHS = {
  templates: '/api/v1/network/notification-templates',
  template: (id: string) => `/api/v1/network/notification-templates/${id}`,
  versions: (id: string) => `/api/v1/network/notification-templates/${id}/versions`,
  version: (id: string, version: number, locale?: string) =>
    `/api/v1/network/notification-templates/${id}/versions/${String(version)}${
      locale ? `?locale=${locale}` : ''
    }`,
  preview: (id: string, version: number) =>
    `/api/v1/network/notification-templates/${id}/versions/${String(version)}/preview`,
  submit: (id: string) => `/api/v1/network/notification-templates/${id}/submit`,
  approve: (id: string) => `/api/v1/network/notification-templates/${id}/approve`,
  retire: (id: string) => `/api/v1/network/notification-templates/${id}/retire`,
  testSend: (id: string) => `/api/v1/network/notification-templates/${id}/test-send`,
  preferences: '/api/v1/me/notification-preferences',
} as const;
